/*
 * iOS-safe body scroll lock for the custom mobile hamburger drawer.
 *
 * Why: sections/header.liquid uses a custom `toggleMobileMenu()` that opens
 * #mobile-menu-drawer by toggling the `translate-x-full` class, but it never
 * locks the page behind the drawer — so the background scrolls while the drawer
 * is open. Plain `overflow:hidden` on <body> is also ignored by iOS Safari for
 * touch scrolling, so a class-based lock is not enough. This watches the
 * drawer's open/close class and applies a `position: fixed` lock (preserving
 * scroll position), which iOS honors. No Dawn / header markup is modified.
 *
 * Revert: delete this file and its <script> include in layout/theme.liquid.
 */
(function () {
  if (window.__menuDrawerScrollLock) return;
  window.__menuDrawerScrollLock = true;

  const DRAWER_ID = 'mobile-menu-drawer';
  const CLOSED_CLASS = 'translate-x-full';
  // The drawer is `md:hidden`, so it is never visible at >=768px (Tailwind md).
  // The lock must never persist there — e.g. opened on mobile then rotated /
  // resized to desktop, where the drawer disappears with no close control.
  const DESKTOP_MQ = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;

  const LOCK_PROPS = ['position', 'top', 'left', 'right', 'width', 'paddingRight'];
  let savedScrollY = null;
  let savedStyles = null;
  let observer = null;

  function applyLock() {
    if (savedScrollY !== null) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const style = document.body.style;
    // Snapshot any pre-existing inline values so releaseLock can restore them
    // instead of blindly clearing styles the lock did not set.
    savedStyles = {};
    LOCK_PROPS.forEach(function (prop) {
      savedStyles[prop] = style[prop];
    });
    style.position = 'fixed';
    // scrollY / scrollbarWidth はスクロール位置由来のピクセル値。rem 変換すると
    // font-size 変動に依存して復元位置がずれるため、ここは意図的に px のまま使う。
    style.top = '-' + savedScrollY + 'px';
    style.left = '0';
    style.right = '0';
    style.width = '100%';
    if (scrollbarWidth > 0) style.paddingRight = scrollbarWidth + 'px';
  }

  function releaseLock() {
    if (savedScrollY === null) return;
    const y = savedScrollY;
    savedScrollY = null;
    const style = document.body.style;
    if (savedStyles) {
      LOCK_PROPS.forEach(function (prop) {
        style[prop] = savedStyles[prop];
      });
      savedStyles = null;
    }
    // behavior:'instant' so a global `scroll-behavior: smooth` does not animate
    // the restore (which would look like the page slides on drawer close).
    window.scrollTo({ top: y, left: 0, behavior: 'instant' });
  }

  // Lock only when the drawer is open (closed transform class absent) AND
  // actually visible (mobile viewport — it is md:hidden on desktop).
  function shouldLock(drawer) {
    if (!drawer) return false;
    if (drawer.classList.contains(CLOSED_CLASS)) return false;
    if (DESKTOP_MQ && DESKTOP_MQ.matches) return false;
    return true;
  }

  function sync(drawer) {
    if (shouldLock(drawer)) {
      applyLock();
    } else {
      releaseLock();
    }
  }

  function syncCurrent() {
    sync(document.getElementById(DRAWER_ID));
  }

  function init() {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    // Theme editor re-renders the header section, destroying the old drawer +
    // observer; disconnect any previous observer before re-binding.
    if (observer) observer.disconnect();
    sync(drawer); // honor an already-open drawer on (re)load
    observer = new MutationObserver(function () {
      sync(drawer);
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind when the header section is reloaded in the Shopify theme editor.
  document.addEventListener('shopify:section:load', init);
  // Release (or re-apply) the lock when crossing the md breakpoint while open.
  if (DESKTOP_MQ) {
    if (DESKTOP_MQ.addEventListener) {
      DESKTOP_MQ.addEventListener('change', syncCurrent);
    } else if (DESKTOP_MQ.addListener) {
      DESKTOP_MQ.addListener(syncCurrent);
    }
  }

  // Exposed for unit testing (harmless in the browser).
  window.__menuDrawerScrollLockApi = { applyLock, releaseLock, sync, shouldLock, syncCurrent, init };
})();
